var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 265,
    viewBox: "0 0 435 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_9068_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435 245.157V182.855C434.966 177.862 433.067 173.063 429.677 169.405C426.287 165.746 421.652 163.493 416.686 163.09C409.015 162.472 401.856 158.989 396.627 153.33C391.398 147.672 388.481 140.251 388.454 132.539C388.483 124.829 391.399 117.411 396.627 111.754C401.854 106.098 409.01 102.614 416.679 101.995C421.645 101.592 426.28 99.3386 429.67 95.6799C433.06 92.0212 434.959 87.2224 434.993 82.2297L435 19.8639C434.995 14.5991 432.906 9.55135 429.191 5.82857C425.476 2.10578 420.439 0.0121077 415.186 0.00706315L316.086 0C309.956 0.0120599 303.912 1.44472 298.427 4.18596C297.369 4.70981 296.205 4.9823 295.025 4.9823C293.845 4.9823 292.68 4.70981 291.622 4.18596C286.135 1.44267 280.088 0.0122235 273.956 0.00706584L19.8144 0.00706315C14.5608 0.0121077 9.52387 2.10578 5.80905 5.82857C2.09423 9.55135 0.00503379 14.5991 0 19.8639L0.035216 82.2015C0.0690241 87.1942 1.96823 91.993 5.35833 95.6517C8.74843 99.3104 13.3834 101.563 18.3492 101.967C26.0388 102.546 33.2258 106.016 38.4701 111.682C43.7144 117.347 46.6285 124.79 46.6285 132.518C46.6285 140.245 43.7143 147.688 38.4701 153.353C33.2258 159.019 26.0388 162.489 18.3492 163.069C13.3834 163.472 8.74843 165.725 5.35833 169.384C1.96823 173.042 0.0690214 177.841 0.0352133 182.834V245.136C0.0402471 250.401 2.12946 255.449 5.84428 259.171C9.5591 262.894 14.596 264.988 19.8496 264.993H273.992C280.121 264.989 286.165 263.561 291.651 260.821C292.71 260.293 293.877 260.019 295.06 260.019C296.243 260.019 297.41 260.293 298.469 260.821C303.952 263.561 309.994 264.991 316.121 265L415.221 264.993C420.465 264.979 425.489 262.884 429.196 259.167C432.903 255.449 434.989 250.412 435 245.157Z",
    fill: "url(#paint0_linear_9068_904)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9068_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.516 234.336C273.632 234.336 319.123 188.748 319.123 132.511C319.123 76.2747 273.632 30.686 217.516 30.686C161.399 30.686 115.908 76.2747 115.908 132.511C115.908 188.748 161.399 234.336 217.516 234.336Z",
    fill: "url(#paint1_linear_9068_904)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.516 234.336C273.632 234.336 319.123 188.748 319.123 132.511C319.123 76.2747 273.632 30.686 217.516 30.686C161.399 30.686 115.908 76.2747 115.908 132.511C115.908 188.748 161.399 234.336 217.516 234.336Z",
    fill: "url(#paint2_linear_9068_904)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.021 131.946L225.733 216.24C224.545 217.428 222.935 218.095 221.256 218.095C219.578 218.095 217.968 217.428 216.779 216.24L141.491 131.946C140.903 131.358 140.437 130.66 140.119 129.892C139.8 129.123 139.637 128.299 139.637 127.467C139.637 126.635 139.8 125.811 140.119 125.043C140.437 124.274 140.903 123.576 141.491 122.989L173.093 82.7834C175.052 80.1539 178 78.1941 181.127 79.032H261.386C264.764 78.1264 267.84 80.5274 269.668 83.5107L301.021 122.99C301.609 123.577 302.075 124.275 302.393 125.044C302.711 125.812 302.875 126.636 302.875 127.468C302.875 128.3 302.711 129.123 302.393 129.892C302.075 130.66 301.609 131.358 301.021 131.946Z",
    fill: "url(#paint3_linear_9068_904)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.788 124.061L219.298 207.562C218.123 208.739 216.53 209.4 214.869 209.4C213.208 209.4 211.615 208.739 210.44 207.562L135.95 124.061C135.368 123.478 134.907 122.787 134.592 122.025C134.277 121.264 134.115 120.448 134.115 119.624C134.115 118.8 134.277 117.984 134.592 117.223C134.907 116.462 135.368 115.77 135.95 115.188L167.216 75.3598C169.155 72.7551 172.072 70.8138 175.165 71.644H254.574C257.915 70.7472 260.959 73.1255 262.767 76.0806L293.789 115.186C294.371 115.769 294.832 116.461 295.147 117.222C295.462 117.983 295.624 118.799 295.624 119.624C295.624 120.448 295.462 121.264 295.147 122.025C294.832 122.787 294.37 123.478 293.788 124.061Z",
    fill: "#FF9CA8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.774 124.058L219.284 207.56C218.109 208.737 216.516 209.398 214.855 209.398C213.194 209.398 211.601 208.737 210.426 207.56L214.822 130.542L214.97 71.6415H254.56C257.901 70.7446 260.945 73.123 262.753 76.0781L293.775 115.184C294.357 115.766 294.819 116.458 295.133 117.219C295.448 117.981 295.61 118.797 295.61 119.621C295.61 120.446 295.448 121.262 295.133 122.023C294.818 122.784 294.356 123.476 293.774 124.058Z",
    fill: "#C2364D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.601 130.234L233.083 192.265L219.319 207.552C218.144 208.729 216.55 209.39 214.889 209.39C213.228 209.39 211.635 208.729 210.46 207.552L196.632 192.265L169.711 130.234H260.601Z",
    fill: "#FF7B89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.572 130.245H169.681C169.681 130.245 134.019 120.99 134.115 119.268C134.201 117.729 134.85 116.276 135.94 115.188L167.206 75.3598C169.145 72.7551 172.062 70.8138 175.155 71.644H254.564C257.905 70.7472 260.949 73.1255 262.757 76.0806L293.779 115.186C294.38 115.787 294.853 116.504 295.168 117.294C295.483 118.084 295.634 118.93 295.612 119.78C295.573 121.335 260.572 130.245 260.572 130.245Z",
    fill: "#FF7B89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.864 130.245H169.681C169.681 130.245 134.019 120.99 134.115 119.268C134.201 117.729 134.85 116.276 135.94 115.188L167.206 75.3598C169.145 72.7551 172.062 70.8138 175.155 71.644H214.972L214.864 130.245Z",
    fill: "#FFE1CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.601 130.238H169.711L215.012 71.4165L260.601 130.238Z",
    fill: "#FF9CA8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_9068_904",
    x: 0,
    y: -4,
    width: 435,
    height: 273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.575 0 0 0 0 0.622575 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9068_904"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.47451 0 0 0 0 0.529412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_9068_904",
    result: "effect2_innerShadow_9068_904"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9068_904",
    x: 115.908,
    y: 30.686,
    width: 207.215,
    height: 207.65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9068_904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9068_904",
    x1: 420.232,
    y1: -0.759914,
    x2: 17.2606,
    y2: 265.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9068_904",
    x1: 217.516,
    y1: 234.324,
    x2: 217.516,
    y2: 30.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B02B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#D14E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E46071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9068_904",
    x1: 217.516,
    y1: 234.324,
    x2: 217.516,
    y2: 30.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B02B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#D14E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E46071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9068_904",
    x1: 221.257,
    y1: 218.095,
    x2: 221.257,
    y2: 78.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35191B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#733F43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokTicket);
export default __webpack_public_path__ + "static/media/tiktok_ticket.9452a8465e4bddd1cb530554118ed683.svg";
export { ForwardRef as ReactComponent };